module.exports = __webpack_public_path__ + "34316106231cd7c7b61c0fe56bfcbe80.pdf";